import React from "react";
import Bluedots from "../../assets/images/blue_dotes.png";

function Contactform() {
  return (
    <>
      <section
        id="contact"
        className="contact_form white_text row_am"
        data-aos="fade-in"
        data-aos-duration={1500}
      >
        <div className="contact_inner">
          <div className="container">
            <div className="dotes_blue">
              <img src={Bluedots} alt="" />
            </div>
            <div
              className="section_title"
              data-aos="fade-up"
              data-aos-duration={1500}
              data-aos-delay={100}
            >
              <span className="title_badge">Contact</span>
              <h2>Envoyez-nous un message</h2>
              <p>
                Remplissez le formulaire ci-dessous, notre équipe vous répondra
                rapidement.
              </p>
            </div>
            <form data-aos="fade-up" data-aos-duration={1500}>
              <div className="row">
                <div className="col-md-4">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Nom *"
                      required=""
                    />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Email *"
                      required=""
                    />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Téléphone"
                    />
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="form-group">
                    <textarea
                      className="form-control"
                      placeholder="Commentaires"
                      defaultValue={""}
                    />
                  </div>
                </div>
                <div className="col-md-8">
                  <div className="coustome_checkbox">
                    <label htmlFor="term_checkbox">
                      <input type="checkbox" id="term_checkbox" />
                      <span className="checkmark" />
                      J’accepte de recevoir des emails, newsletters et
                      informations de Neoori.
                    </label>
                  </div>
                </div>
                <div className="col-md-4 text-right">
                  <div className="btn_block">
                    <button className="btn puprple_btn ml-0">Envoyer</button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </section>
    </>
  );
}

export default Contactform;
